<template>
    <div class="header-top" v-if="path !== '/'">
        <span class="fristpage">
            <van-icon name="arrow-left" @click="goback" />
        </span>
        <span class="slogan">L.L Golf Academy</span>
        <span class="logout">
            <span v-if="userType != 2">
                <span v-if="icon">
                    <img
                        v-if="path === '/studentTask'"
                        style="width: 30px; height: 30px; margin-right: 10px"
                        src="../assets/img/tongbubububu.svg"
                        @click="tongbu"
                        alt=""
                    />
                </span>
            </span>

            <span v-if="userType != 2">
                <span v-if="icon">
                    <img
                        v-if="path !== '/'"
                        style="width: 20px; height: 20px"
                        src="../assets/img/adddd.svg"
                        @click="rightTop"
                        alt=""
                    />
                </span>
            </span>
        </span>

        <van-popup v-model="show" position="bottom" :style="{ height: '70%' }">
            <van-checkbox-group v-model="studentResult" @change="studentChange">
                <div class="fuzhujiaotitle">
                    <span class="cancel" @click="show = false">取消</span>
                    <span class="t">同步任务</span>
                    <span class="confirm" @click="confirm">确认</span>
                </div>
                <van-cell-group>
                    <van-cell title="选择日期" :value="time" is-link @click="clickCell" />
                    <van-cell
                        v-for="(item, index) in studentList"
                        clickable
                        :key="item.id"
                        :title="`${item.name}`"
                        @click="studentToggle(index)"
                    >
                        <template #right-icon>
                            <van-checkbox :name="item.id" ref="studentCheckboxes" />
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </van-popup>

        <!-- 时间选择 -->
        <van-popup v-model="timeShow" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                type="date"
                title="选择日期"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="confirmTimeShow"
                @cancel="timeShow = false"
                v-model="selectTime"
            />
        </van-popup>
    </div>
</template>

<script>
import { Icon, Popup, Toast, Cell, Picker, CheckboxGroup, Checkbox, CellGroup, DatetimePicker } from 'vant'
import { changeDate } from '../utils.js'

export default {
    name: 'HeaderTop',
    props: {
        currentDay: {
            type: String,
            default: ''
        }
    },
    components: {
        [Icon.name]: Icon,
        [Popup.name]: Popup,
        [Picker.name]: Picker,
        [CellGroup.name]: CellGroup,
        [CheckboxGroup.name]: CheckboxGroup,
        [Checkbox.name]: Checkbox,
        [Cell.name]: Cell,
        [Toast.name]: Toast,
        [DatetimePicker.name]: DatetimePicker
    },
    data() {
        return {
            show: false,
            studentResult: [],
            studentList: [],
            timeShow: false,
            selectTime: new Date(),
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(),
            currentDate: new Date()
        }
    },
    computed: {
        time() {
            return changeDate(this.selectTime)
        },
        path() {
            return this.$route.path
        },
        icon() {
            return this.$route.path === '/studentTask' && this.$route.query.trainType === 'next_training' ? false : true
        },
        userType() {
            return JSON.parse(localStorage.getItem('userInfo'))?.user?.userType
        }
    },
    watch: {},
    methods: {
        goback() {
            console.log(this.path)
            if (this.path !== '/') {
                this.$router.go(-1)
            }
        },
        rightTop() {
            // 获取当前路由
            // 当前是登录页面
            // if (this.path === '/') {
            //     window.
            //         window.location.href = "http://47.96.111.233:9200/#/pages/index"
            // }
            // 当前是 每日训练页面
            if (this.path === '/everyTrain') {
                this.$router.push({ path: '/addTrain' })
            }
            // 当前是 每日训练页面
            if (this.path === '/studentTask') {
                let studentId = this.$store.state.addTaskActived.id
                let taskId = this.$store.state.addTaskActived.taskId
                this.$router.push({ path: '/addTask', query: { studentId, taskId } })
            }
        },
        // goBack() {
        //     this.$router.go(-1)
        // },
        tongbu() {
            // let data = {
            //     studentId: this.$store.state.addTaskActived.id,
            //     trainId: this.$route.query.trainId
            //     // currentDay: localStorage.getItem('currentDayStr'),
            //     // trainType: this.$route.query.trainType
            // }
            // this.$api.coach.syncStudent(data).then((res) => {
            //     if (res.msg) {
            //
            //         return
            //     }
            //     this.studentList = res.data.stuList.map((item) => {
            //         let data = {
            //             id: item.id,
            //             name: item.name
            //         }
            //         return data
            //     })
            this.show = true
            this.selectTimeGetStudent()
            // })
        },
        studentToggle(index) {
            this.$refs.studentCheckboxes[index].toggle()
        },
        studentChange() {},
        confirm() {
            let params = {
                selectStuId: localStorage.getItem('currentStudentStr'),
                trainId: this.$route.query.trainId,
                currentDay: changeDate(this.selectTime),
                studentIds: this.studentResult
            }
            this.$api.train.syncTask(params).then((res) => {
                if (res.msg) {
                    //
                    return
                }
                this.show = false
                this.$store.commit('SET_SYNC_TASK', new Date().getTime())
                this.studentList = []
                this.studentResult = []

                Toast.success('同步成功')
            })
        },
        // 选择日期
        clickCell() {
            this.timeShow = true
        },
        // 确定时间
        confirmTimeShow() {
            this.studentList = []
            this.selectTimeGetStudent()
            this.timeShow = false
        },
        // 选择日期获取学员列表
        selectTimeGetStudent() {
            this.$api.train.getSyncTaskStu(changeDate(this.selectTime)).then((res) => {
                if (res.msg) {
                    //
                    return
                }
                this.studentList = res.data.map((item) => {
                    let data = {
                        id: item.id,
                        name: item.name
                    }
                    return data
                })
            })
        }
    },

    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    activated() {},
    deactivated() {},
    beforeDestroy() {},
    destroyed() {}
}
</script>

<style scoped lang="less">
.header-top {
    width: 100%;
    height: 45px;
    background-color: rgba(32, 98, 53, 1);
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;

    .fristpage[data-v-7a713388] {
        font-size: 20px;
    }

    .slogan {
        font-size: 16px;
    }

    .fristpage {
        font-size: 13px;
    }

    .logout {
        font-size: 13px;
    }

    .fuzhujiaotitle {
        width: 100%;
        height: 44px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .cancel {
            color: #969799;
            margin-left: 16px;
        }

        .t {
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            text-align: center;
            color: #555;
        }

        .confirm {
            color: #576b95;
            margin-right: 16px;
        }
    }
    ::v-deep .van-popup--bottom {
        .van-picker__toolbar {
            .van-picker__title {
                color: #555 !important;
            }
        }
    }
}
</style>
